<template>
  <div class="datav-map" :style="{ width:`calc( 100vw - ${isCollapse ? '60' : '160'}px` }">
    <datav-map-main ref="mainMap" class="main" @equip-click="handleEquipClick" />

    <div class="top flex-center column">
      <div class="console-title flex-center">
        <input
          v-if="consoleTitleEditing"
          ref="consoleTitleInput"
          v-model="consoleTitleInput"
          :style="{ width: inputWidth }"
          @input="_computeInputWidth"
          @blur="submitConsoleTitle"
          @keyup.enter="submitConsoleTitle"
        />
        <el-tooltip v-else effect="light" content="点击可修改自定义标题">
          <span @click="editConsoleTitle">{{ customization.console_title || 'AIoT 平台' }}</span>
        </el-tooltip>
        <span ref="hideConsoleTitle" style="position: fixed; top: -10000px">{{ consoleTitleInput }}</span>
      </div>
      <div class="mt-xs font-sm text-muted">Data from <a href="https://www.frippler.com" target="_blank">Frippler</a></div>
    </div>

    <div class="left">
      <div class="panel" style="position: absolute;top: 0px;height: 360px;">
        <div class="title">设备概览</div>
        <div class="body">
          <datav-map-equip-stats ref="equipStats" @equip-total-change="handleEquipTotalChange" />
        </div>
      </div>

      <div class="panel" style="position: absolute;top: 380px;bottom: 0px;">
        <div class="title">最新事件</div>
        <div class="body">
          <datav-map-event-list ref="eventList" @equip-click="handleEquipClick" @equip-hover="handleEquipHover" />
        </div>
      </div>
    </div>

    <div class="right">
      <div class="panel" style="position: absolute;top: 0px;height: 360px;">
        <div class="title">用户活跃度</div>
        <div class="body">
          <datav-map-visit-stats ref="visitStats" />
        </div>
      </div>

      <div class="panel" style="position: absolute;top: 380px;bottom: 0px;">
        <div class="title">最新访问</div>
        <div class="body">
          <datav-map-visit-list ref="visitList" @equip-click="handleEquipClick" @equip-hover="handleEquipHover" />
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'DatavMap',

  components: {
    DatavMapMain: () => import('./components/DatavMapMain'),
    DatavMapEquipStats: () => import('./components/DatavMapEquipStats'),
    DatavMapEventList: () => import('./components/DatavMapEventList'),
    DatavMapVisitStats: () => import('./components/DatavMapVisitStats'),
    DatavMapVisitList: () => import('./components/DatavMapVisitList'),
  },

  data() {
    return {
      consoleTitleEditing: false,
      consoleTitleInput: "",
      inputWidth: "100%",
    }
  },

  computed: {
    isCollapse() {
      return this.$store.state.commonStore.collapse;
    },

    god () {
      return this.$store.state.godStore
    },


    customization () {
      if (this.god.customization) {
        return { ...this.god.customization }
      } else {
        return {}
      }
    },
  },

  watch: {
  },

  created() {
  },

  beforeDestroy() {
  },

  beforeRouteLeave(to, from, next) {
    this.$refs['mainMap'].stopInterval()
    next();
  },
  
  methods: {
    // 编辑标题
    _computeInputWidth() {
      this.inputWidth = this.$refs["hideConsoleTitle"].clientWidth + 100 + "px";
    },
    
    editConsoleTitle() {
      this.consoleTitleInput = this.customization.console_title || "AIoT 平台";
      this.consoleTitleEditing = true;
      this.$nextTick(() => {
        this._computeInputWidth();
        this.$refs["consoleTitleInput"].focus();
      });
    },
    submitConsoleTitle() {
      this.$store
        .dispatch("setGodCustomizationAction", {
          console_title: this.consoleTitleInput,
        })
        .then((res) => {
          this.consoleTitleEditing = false;
        })
        .catch(() => {
          this.consoleTitleEditing = false;
        });
    },

    handleEquipClick(equipid) {
      this.$detail({type:'equip',id:equipid});
    },

    handleEquipHover(equipid) {
      this.$refs['mainMap'].highLightEquip(equipid)
    },

    handleEquipTotalChange(oldVal, newVal) {
      this.$refs['mainMap'].fetchStaticData()
    }
  }
}
</script>

<style lang="scss">
.datav-map {
  position: fixed;
  top: 0px;
  height: 100vh;
  margin: 0px -20px;
  color: #f3f3f3;
  background-color: rgb(11, 18, 37);
  
  >.main {
    width: 100%;
    height: 100%;
  }
  >.top {
    position:absolute;
    left: 420px;
    right: 420px;
    top: 20px;
    height: auto;
    .console-title {
      color: #f3f3f3;
      height: 45px;
      span,
      input {
        color: #f3f3f3;
        padding: 5px 10px;
        font-size: 2em;
        font-weight: 700;
        letter-spacing: 2px;
        transition: all 0.2s;
      }
      input {
        background-color: rgba(255, 255, 255, 0.3);
        border: none;
        text-align: center;
      }
      span:hover {
        background-color: rgba(255, 255, 255, 0.1);
      }
    }
  }
  >.left {
    position: absolute;
    left: 20px;
    width: 400px;
    top: 80px;
    bottom: 20px;
  }
  >.right {
    position: absolute;
    right: 20px;
    width: 400px;
    top: 80px;
    bottom: 20px;
  }
  .panel {
    border-top:2px transparent solid;
    border-image: -webkit-linear-gradient(left, #202632, #b2e6f3, #202632) 30 30;
    width: 100%;
    background-color: rgba(255, 255, 255, 0.15);
    padding: 10px 15px;
    display: flex;
    flex-direction: column;
    .title {
      flex: none;
      text-align: center;
      font-size: 1.2em;
      font-weight: bold;
      letter-spacing: 2px;
    }
    .body {
      flex: auto;
      overflow: hidden;
    }
  }
}
</style>
